module.exports = __webpack_public_path__ + "img/cca789a.png";